import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadDirectlyService } from 'src/app/shared/services/upload-directly.service';

@Component({
  selector: 'app-crop-images',
  templateUrl: './crop-images.component.html',
  styleUrls: ['./crop-images.component.scss']
})
export class CropImagesComponent {
  @Input() imageCarrosel!: string;
  @Input() index: any = 999;

  image = new Image();
  cropedUrl = "";
  canvas!: HTMLCanvasElement;
  context!: CanvasRenderingContext2D | null;
  data: any;
  loading = false;

  timeout:any = null;

  constructor(private uploadDirecltyService: UploadDirectlyService) { }

  ngOnInit(): void {
    let id = "canvas"+this.index;
    this.timeout = setTimeout(async () => {
      this.canvas = document.getElementById(id) as HTMLCanvasElement;

      this.context = this.canvas.getContext("2d");

      let urlCroped = await this.uploadDirecltyService.getUrlCroped(this.imageCarrosel);
      if(urlCroped){
        this.cropedUrl = urlCroped;
        return
      }
      this.loadImage();
    }, 5);

  }

  async setCropedImageUrl(file:File) {
    this.loading = true;
    let url:string | null | Observable<string> = await this.uploadDirecltyService.getUrlCroped(this.imageCarrosel);
    if(url){
      url = url;
      this.cropedUrl = url;
      this.loading = false;
    }else{
      this.uploadDirecltyService.uploadProductCropDirectlyS3(file).subscribe(data => {
        if(data){
          url = data
          this.cropedUrl = data;
          this.loading = false;
          return
        }
        console.error("Erro ao fazer o upload da imagem");
      });

    }

  }

  async loadImage() {
    this.loading = true;
    this.image.onload = async () => {
      this.canvas.width = this.image.width;
      this.canvas.height = this.image.height;

      this.context!.drawImage(this.image, 0, 0, this.image.width, this.image.height);

        let urlCroped = await this.uploadDirecltyService.getUrlCroped(this.imageCarrosel);
        if(!urlCroped){
          this.cropImage();
        }else {
          if(urlCroped)
            this.cropedUrl = urlCroped;
        };
    };


    this.toDataURL(this.imageCarrosel, (dataUrl: string) => {
      this.image.src = dataUrl;
    });
  }

  toDataURL(url: string, callback: Function): void {
    fetch(url, {method: 'GET', headers: { 'Cache-Control': 'no-cache' }})
    .then(response => {

      return response.blob()
    })
    .then(blob => {
      const reader = new FileReader();
      reader.onloadend = () => {
        callback(reader.result);
      };
      reader.readAsDataURL(blob);
    })
    .catch(error => {
      console.error('Erro ao carregar a imagem:', error);
    });
  }

  async cropImage() {
    this.data = this.context!.getImageData(0, 0, this.image.width, this.image.height).data;
    const top = this.scanY(true);
    const bottom = this.scanY(false);
    const left = this.scanX(true);
    const right = this.scanX(false);

    const new_width = right - left;
    const new_height = bottom - top;

    const croppedCanvas = document.createElement('canvas');
    const croppedContext = croppedCanvas.getContext('2d')!;
    croppedCanvas.width = new_width;
    croppedCanvas.height = new_height;

    croppedContext.drawImage(this.canvas, left, top, new_width, new_height, 0, 0, new_width, new_height);
    try {
      croppedCanvas.toBlob(blob => {
          if (blob) {
              const file = new File([blob], this.uploadDirecltyService.getFileNameByUrl(this.imageCarrosel), { type: 'image/png' });
              this.setCropedImageUrl(file);
          } else {
              console.error('Não foi possível converter para Blob.');
          }
      }, 'image/png', 1);
    } catch (error) {
        console.error('Ocorreu um erro ao tentar converter para Blob:', error);
    }

}


  getRGB(x: number, y: number): { red: number, green: number, blue: number, alpha: number } {
    return {
      red: this.data[((this.image.width * y) + x) * 4],
      green: this.data[((this.image.width * y) + x) * 4 + 1],
      blue: this.data[((this.image.width * y) + x) * 4 + 2],
      alpha: this.data[((this.image.width * y) + x) * 4 + 3]
    };
  }

  isColor(rgb: { red: number, green: number, blue: number, alpha: number }): boolean {
    const threshold = 10;

    return (rgb.red == 255 && rgb.green == 255 && rgb.blue == 255) || rgb.alpha < threshold;
  }


  scanY(top: boolean): number {
    const offset = (top) ? 1 : -1;

    for (let y = ((top) ? 0 : this.image.height - 1); ((top) ? (y < this.image.height) : (y > -1)); y += offset) {
      for (let x = 0; x < this.image.width; x++) {
        if (!this.isColor(this.getRGB(x, y))) {
          return y;
        }
      }
    }

    return 0;
  }

  scanX(left: boolean): number {
    const offset = (left) ? 1 : -1;

    for (let x = ((left) ? 0 : this.image.width - 1); ((left) ? (x < this.image.width) : (x > -1)); x += offset) {
      for (let y = 0; y < this.image.height; y++) {
        if (!this.isColor(this.getRGB(x, y))) {
          return x;
        }
      }
    }

    return 0;
  }
  ngOnDestroy() {
    clearTimeout(this.timeout);
  }
}
